import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import PropTypes from "prop-types";
import { useMemo } from "react";

const MultipleSelectPerformanceList = (props) => {
  const {
    handleChange,
    label,
    path,
    data,
    required,
    schema,
    uischema,
    visible,
    enabled,
  } = props;

  const formatData = (data) => {
    if (!data) return [];
    const formattedData = data.map((item) => item.id);
    // If selection is single, return the first item as a string
    return uischema?.selection === "single" && formattedData.length > 0
      ? formattedData[0]
      : formattedData;
  };

  const handleSelectValue = (val) => {
    handleChange(path, formatData(val));
  };

  const formatValue = useMemo(() => {
    // If data is null or undefined, return empty array
    if (!data) return undefined;

    // Convert to array if it's not already one
    const dataArray = Array.isArray(data) ? data : [data];

    return dataArray.map((item) => {
      const options = schema?.items?.options || schema?.options || [];
      const option = options?.find((option) => option.id === item);
      return {
        id: item,
        displayText: option ? option.displayText : item,
      };
    });
  }, [data, schema]);

  return visible ? (
    <div className="multiple-select-wrap">
      <Dropdown
        ref={null}
        label={label}
        childList={schema?.items?.options || schema?.options || []}
        selection={uischema?.selection === "single" ? "single" : "multiple"}
        isRequired={required}
        disabled={!enabled}
        selectedValue={formatValue || undefined}
        placeholder={uischema?.placeholder}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};
MultipleSelectPerformanceList.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  data: PropTypes.array,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.shape({
    selection: PropTypes.string,
    placeholder: PropTypes.string,
  }),
  visible: PropTypes.bool,
  enabled: PropTypes.bool,
};

export const MultipleSelectPerformanceListControl = withJsonFormsMultiEnumProps(
  MultipleSelectPerformanceList
);
